import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/insight/customer.insight.query.gql"
import type {
  CustomerInsightQuery,
  CustomerInsightQueryVariables,
} from "@/v2-backoffice-client/customer/insight/__types__/customer.insight.query"

type Options = QueryHookOptions<
  CustomerInsightQuery,
  CustomerInsightQueryVariables
>

export function useCustomerInsightQuery(options?: Options) {
  return useQuery<CustomerInsightQuery, CustomerInsightQueryVariables>(
    query,
    options,
  )
}
